import * as yup from "yup";

import { LEAVE_ICON_NAMES } from "screens/Vacations/components/LeaveTypes/constants/iconsList";

const baseSchema = yup.object({
  seniorityRequirement: yup
    .string()
    .oneOf(["one_year", "from_first_day"])
    .required("Este campo es obligatorio"),
  minimumEligibilityDays: yup.number().when("seniorityRequirement", {
    is: "from_first_day",
    then: (schema) =>
      schema
        .typeError("El campo debe ser numérico")
        .integer("Debe ser un número entero")
        .required("Este campo es obligatorio")
        .min(
          1,
          "El rango válido de días para disfrutar vacaciones es de 1 a 364",
        )
        .max(
          364,
          "El rango válido de días para disfrutar vacaciones es de 1 a 364",
        ),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  accrualMode: yup
    .string()
    .oneOf(["ANNUAL_GRANTED", "PROPORTIONAL_ACCRUAL"])
    .required("Este campo es obligatorio"),
  allowNegativeBalance: yup
    .string()
    .oneOf(["yes", "no"])
    .required("Este campo es obligatorio"),
  advanceNoticeRequirement: yup
    .string()
    .oneOf(["none", "required"])
    .required("Este campo es obligatorio"),
  minAdvanceNoticeDays: yup.number().when("advanceNoticeRequirement", {
    is: "required",
    then: (schema) =>
      schema
        .typeError("El campo debe ser numérico")
        .integer("Debe ser un número entero")
        .required("Este campo es obligatorio")
        .min(1, "El rango válido de días de anticipación es de 1 a 15")
        .max(15, "El rango válido de días de anticipación es de 1 a 15"),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  allowBackdateDays: yup
    .string()
    .oneOf(["yes", "no"])
    .required("Este campo es obligatorio"),
  maxBackdateDays: yup.number().when("allowBackdateDays", {
    is: "yes",
    then: (schema) =>
      schema
        .typeError("El campo debe ser numérico")
        .integer("Debe ser un número entero")
        .required("Este campo es obligatorio")
        .min(1, "El rango válido de días de fechas pasadas es de 1 a 15")
        .max(15, "El rango válido de días de fechas pasadas es de 1 a 15"),
    otherwise: (schema) => schema.nullable().notRequired(),
  }),
  icon: yup
    .string()
    .oneOf(LEAVE_ICON_NAMES, "El ícono seleccionado no es válido")
    .required("Este campo es obligatorio"),
});

export const validationSchema = baseSchema.transform((value) => {
  const result = { ...value };

  if (value.seniorityRequirement !== "from_first_day") {
    result.minimumEligibilityDays = 365;
  }

  if (value.advanceNoticeRequirement !== "required") {
    result.minAdvanceNoticeDays = null;
  }

  if (value.allowBackdateDays !== "yes") {
    result.maxBackdateDays = null;
  }

  return result;
});
